import React, { Component } from 'react';
import styled from 'styled-components';
import Splash from '../../shared/Splash';
import Footer from '../../shared/Footer';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';
import CTA from './components/CTA';
import SuggestedCourse from './components/SuggestedCourse';
import WhyChooseUs from '../../shared/WhyChooseUs';
import Requirements from '../../shared/Requirements';
import Accreditations from '../../shared/Accreditations';
import Content from '../../shared/Content';
import Instructor from '../../shared/Instructor';
import Testimonials2 from '../../shared/Testimonials2';
import AboutSplash from '../../../assets/aboutBanner.jpg';
import SuggestedCoursesForBundles from './components/SuggestedCoursesForBundles';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const Grid = styled.div`
  width: 95%;
  display: grid;
  grid-gap: 35px;
  height: 100%;
  margin: 2em auto;
  grid-template-columns: 1fr 2fr 1fr;
  grid-auto-rows: 550px auto;
  grid-template-areas:
    'w r a'
    'c c c';
  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    grid-template-areas:
      'r '
      'w '
      'a '
      'c';
  }
`;

const Div = styled.div`
  width: 100%;
  height: 100%;
  background: #cfd3dc;
  padding: 3em 0;
  margin: 0 auto;
`;

class Course extends Component {
  state = {
    isOpen: false,
  };
  formatPrice = x => {
    return (x / 100).toFixed(2);
  };

  isAuthenticated = () => {
    return localStorage.getItem('authorization');
  };

  handleSubmit = () => {
    if (this.isAuthenticated()) {
      window.location.href = `${this.props.checkoutLink}`;
    } else {
      this.props.history.push({
        pathname: '/signup',
        state: { link: `${this.props.checkoutLink}` },
      });
    }
  };

  handleClick = () => {
    this.setState(prevState => {
      return {
        isOpen: !prevState.isOpen,
      };
    });
  };

  render() {
    const {
      slug,
      aboutThisCourse,
      // img,
      requirementsDescription,
      textOverlayTitleMainArtwork,
      textOverlayDescMainArtwork,
      price,
      checkoutLink,
      learnMore,
      accreditations,
      instructor,
      type,
      gTagManagerId,
    } = this.props;
    console.log(gTagManagerId, 'ad');
    return (
      <Wrapper>
        <Helmet
          title={`${slug} | AchieveCE`}
          meta={[
            {
              name: 'description',
              content: `${slug} page for AchieveCE`,
            },
            { property: 'og:type', content: 'website' },
            { property: 'og:title', content: 'Approved Continuing Education' },
            { property: 'og:url', content: 'http://achievece.com' },
          ]}
        >
          {/* <script
            async
            src={`https://www.googletagmanager.com/gtag/js?id=${gTagManagerId}`}
          />
          <script>
            {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', ${gTagManagerId});
        `}
          </script> */}
        </Helmet>
        <Splash
          img={AboutSplash}
          text={[textOverlayTitleMainArtwork, textOverlayDescMainArtwork]}
          id="course"
          price={price}
          formatPrice={this.formatPrice}
          handleSubmit={this.handleSubmit}
          checkoutLink={checkoutLink}
        />

        <Div>
          <Grid>
            <WhyChooseUs />
            <Requirements
              aboutThisCourse={aboutThisCourse}
              requirementsDescription={requirementsDescription}
              type={type}
              handleSubmit={this.handleSubmit}
              checkoutLink={checkoutLink}
            />
            <Accreditations accreditations={accreditations} />
            <Content
              handleClick={this.handleClick}
              isOpen={this.state.isOpen}
              learnMore={learnMore && learnMore}
            />
          </Grid>
        </Div>
        {instructor && <Instructor instructor={instructor} />}
        <CTA
          price={price}
          formatPrice={this.formatPrice}
          handleSubmit={this.handleSubmit}
          checkoutLink={checkoutLink}
        />
        {type === 'course' && <SuggestedCourse />}
        {type === 'bundle' && <SuggestedCoursesForBundles />}
        <Testimonials2 />
        <Footer />
      </Wrapper>
    );
  }
}

export default withRouter(Course);



// WEBPACK FOOTER //
// ./src/components/screens/Course/Course.jsx